import { keepPreviousData, useQuery } from '@tanstack/react-query';

// Models
import { PaginationPayload } from 'app/shared/pagination/models';
import { PaginatedDispositionsResponse } from 'app/modules/dispositions/response';

// Query Keys
import { DISPOSITION_QUERY_KEYS } from 'app/modules/dispositions/queries/keys';
import { post } from 'app/shared/utils/fetchr';

export const getDispositions = (
  payload: PaginationPayload,
): Promise<PaginatedDispositionsResponse> => {
  return post(`/v1/dispositions/list`, payload);
};

export const useGetDispositions = (payload: PaginationPayload) => {
  return useQuery({
    queryKey: DISPOSITION_QUERY_KEYS.getDispositions(payload),
    queryFn: (): Promise<PaginatedDispositionsResponse> =>
      getDispositions(payload),
    // Use placeholder data for smooth pagination transitions
    placeholderData: keepPreviousData,
    enabled: payload.limit > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
